import { useEffect, useRef } from "react";
import { Checkbox as MuiCheckbox, FormControlLabel, styled } from "@mui/material";

const StyledFormControlLabel = styled(FormControlLabel)({
  margin: 0,
  alignItems: "center",
});

const StyledCheckbox = styled(MuiCheckbox, {
  shouldForwardProp: (prop) => prop !== "error",
})<{ error: boolean }>(({ theme, error }) => ({
  color: error ? theme.palette.error.main : theme.palette.border.strong,
  "&.MuiCheckbox-root": {
    padding: "0",
    marginRight: "12px",
  },
}));

interface CheckboxProps {
  checked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  label: React.ReactNode;
  error?: boolean;
}

export const Checkbox = ({ checked, onChange, label, error }: CheckboxProps) => {
  const ref = useRef<HTMLLabelElement>(null);

  useEffect(() => {
    if (error) {
      if (!ref.current) return;
      ref.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }, [ref, error]);

  return (
    <StyledFormControlLabel
      ref={ref}
      control={
        <StyledCheckbox checked={checked} onChange={onChange} error={error || false} />
      }
      label={label}
    />
  );
};
